module.exports = __webpack_public_path__ + "img/top.128f48bd.png";